(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-bf-marquee]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const toggle = root.querySelector('[data-marquee-toggle]');
      let paused = reduced.matches, hover = false, focused = false;
      let last = 0, frame = 0, measureFrame = 0, visible = false;
      const rows = [...root.querySelectorAll('[data-marquee-row]')].map(el => {
        const group = el.querySelector('.bf-marquee-group');
        const row = { el, group, position: 0, width: 0, copies: [] };
        el.addEventListener('touchstart', () => { hover = true; schedule(); }, { passive: true });
        ['touchend', 'touchcancel'].forEach(event => el.addEventListener(event, () => {
          hover = false; schedule();
        }, { passive: true }));
        el.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            paused = true; update();
          }
        });
        el.addEventListener('scroll', () => { row.position = el.scrollLeft; }, { passive: true });
        return row;
      });
      // Measure all rows before changing the DOM. One repeat is enough whenever
      // the original group is wider than the viewport; do not clone by screen size.
      function prepare() {
        if (!visible || measureFrame) return;
        measureFrame = requestAnimationFrame(() => {
          measureFrame = 0;
          if (!root.isConnected || !visible) return;
          const measurements = rows.map(row => ({ row,
            width: row.group.getBoundingClientRect().width,
            viewport: row.el.clientWidth
          }));
          measurements.forEach(({ row, width, viewport }) => {
            row.width = width;
            const needed = reduced.matches || !width ? 0 : Math.ceil(viewport / width);
            while (row.copies.length > needed) row.copies.pop().remove();
            while (row.copies.length < needed) {
              const copy = row.group.cloneNode(true);
              copy.dataset.marqueeClone = '';
              copy.setAttribute('aria-hidden', 'true');
              copy.inert = true;
              row.group.parentElement.append(copy);
              row.copies.push(copy);
            }
          });
          schedule();
        });
      }
      const resize = new ResizeObserver(prepare);
      rows.forEach(row => { resize.observe(row.group); resize.observe(row.el); });
      const canRun = () => !paused && !hover && !focused && visible && !document.hidden && root.isConnected;
      function schedule() {
        if (canRun()) {
          if (!frame) frame = requestAnimationFrame(tick);
        } else {
          cancelAnimationFrame(frame);
          frame = 0; last = 0;
        }
      }
      function update() {
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? 'Reanudar movimiento' : 'Pausar movimiento';
        schedule();
      }
      function tick(now) {
        frame = 0;
        if (!canRun()) { last = 0; return; }
        const elapsed = last ? Math.min(now - last, 64) : 0;
        last = now;
        rows.forEach(row => {
          if (!row.width) return;
          const direction = Number(row.el.dataset.direction);
          row.position = (row.position + direction * elapsed * .026 + row.width) % row.width;
          row.el.scrollLeft = row.position;
        });
        schedule();
      }
      toggle.addEventListener('click', () => { paused = !paused; update(); });
      root.addEventListener('focusin', event => {
        focused = event.target !== toggle && event.target.matches(':focus-visible'); schedule();
      });
      root.addEventListener('focusout', event => {
        focused = !!event.relatedTarget && root.contains(event.relatedTarget) && event.relatedTarget !== toggle;
        schedule();
      });
      const onReduced = () => { paused = reduced.matches; prepare(); update(); };
      reduced.addEventListener('change', onReduced);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting; prepare(); schedule();
      });
      observer.observe(root);
      document.addEventListener('visibilitychange', schedule);
      const unload = event => {
        if (!event.target.contains(root)) return;
        cancelAnimationFrame(frame); cancelAnimationFrame(measureFrame);
        observer.disconnect(); resize.disconnect();
        reduced.removeEventListener('change', onReduced);
        document.removeEventListener('visibilitychange', schedule);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
